import { render, staticRenderFns } from "./ClienteTipoPedidoB2BEmpresaModal.vue?vue&type=template&id=0a7d499a&scoped=true"
import script from "./ClienteTipoPedidoB2BEmpresaModal.vue?vue&type=script&lang=js"
export * from "./ClienteTipoPedidoB2BEmpresaModal.vue?vue&type=script&lang=js"
import style0 from "./ClienteTipoPedidoB2BEmpresaModal.vue?vue&type=style&index=0&id=0a7d499a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7d499a",
  null
  
)

export default component.exports